/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  NewAgencyRequest,
  PlatformAgency,
  PlatformAgencyCreated
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Super-admin: every agency with its onboarding; POST creates one and invites its owner.
 */
export type platformAgenciesListResponse200 = {
  data: PlatformAgency[]
  status: 200
}
    
export type platformAgenciesListResponseSuccess = (platformAgenciesListResponse200) & {
  headers: Headers;
};
;

export type platformAgenciesListResponse = (platformAgenciesListResponseSuccess)

export const getPlatformAgenciesListUrl = () => {


  

  return `/api/v1/platform/agencies/`
}

export const platformAgenciesList = async ( options?: RequestInit): Promise<platformAgenciesListResponse> => {
  
  return apiFetch<platformAgenciesListResponse>(getPlatformAgenciesListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getPlatformAgenciesListQueryKey = () => {
    return [
    `/api/v1/platform/agencies/`
    ] as const;
    }

    
export const getPlatformAgenciesListQueryOptions = <TData = Awaited<ReturnType<typeof platformAgenciesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformAgenciesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPlatformAgenciesListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof platformAgenciesList>>> = ({ signal }) => platformAgenciesList({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof platformAgenciesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformAgenciesListQueryResult = NonNullable<Awaited<ReturnType<typeof platformAgenciesList>>>
export type PlatformAgenciesListQueryError = unknown


export function usePlatformAgenciesList<TData = Awaited<ReturnType<typeof platformAgenciesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformAgenciesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAgenciesList>>,
          TError,
          Awaited<ReturnType<typeof platformAgenciesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformAgenciesList<TData = Awaited<ReturnType<typeof platformAgenciesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformAgenciesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof platformAgenciesList>>,
          TError,
          Awaited<ReturnType<typeof platformAgenciesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePlatformAgenciesList<TData = Awaited<ReturnType<typeof platformAgenciesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformAgenciesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePlatformAgenciesList<TData = Awaited<ReturnType<typeof platformAgenciesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof platformAgenciesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPlatformAgenciesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Super-admin: every agency with its onboarding; POST creates one and invites its owner.
 */
export type platformAgenciesCreateResponse201 = {
  data: PlatformAgencyCreated
  status: 201
}
    
export type platformAgenciesCreateResponseSuccess = (platformAgenciesCreateResponse201) & {
  headers: Headers;
};
;

export type platformAgenciesCreateResponse = (platformAgenciesCreateResponseSuccess)

export const getPlatformAgenciesCreateUrl = () => {


  

  return `/api/v1/platform/agencies/`
}

export const platformAgenciesCreate = async (newAgencyRequest: NewAgencyRequest, options?: RequestInit): Promise<platformAgenciesCreateResponse> => {
  
  return apiFetch<platformAgenciesCreateResponse>(getPlatformAgenciesCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      newAgencyRequest,)
  }
);}




export const getPlatformAgenciesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAgenciesCreate>>, TError,{data: NewAgencyRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof platformAgenciesCreate>>, TError,{data: NewAgencyRequest}, TContext> => {

const mutationKey = ['platformAgenciesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof platformAgenciesCreate>>, {data: NewAgencyRequest}> = (props) => {
          const {data} = props ?? {};

          return  platformAgenciesCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PlatformAgenciesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof platformAgenciesCreate>>>
    export type PlatformAgenciesCreateMutationBody = NewAgencyRequest
    export type PlatformAgenciesCreateMutationError = unknown

    export const usePlatformAgenciesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof platformAgenciesCreate>>, TError,{data: NewAgencyRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof platformAgenciesCreate>>,
        TError,
        {data: NewAgencyRequest},
        TContext
      > => {

      const mutationOptions = getPlatformAgenciesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    